import type { RequiredErrors, RequiredFieldSpec } from '../../utils/requiredValidation';

/** Validation keys for attachments that remain read-only on Case Update (Civil Advise / Civil Appellate). */
const UPDATE_SKIP_UPLOAD_ERROR_KEYS = new Set([
  'previousAdviceFiles',
  'judgmentOrOrderDocuments',
]);

/** Drop attachment-required errors so Save is not blocked when files are view-only. */
export function omitCaseUpdateUploadErrors(errors: RequiredErrors): RequiredErrors {
  const next: RequiredErrors = {};
  for (const [key, message] of Object.entries(errors)) {
    if (UPDATE_SKIP_UPLOAD_ERROR_KEYS.has(key)) continue;
    next[key] = message;
  }
  return next;
}

export function omitCaseUpdateUploadSpecs(specs: RequiredFieldSpec[]): RequiredFieldSpec[] {
  return specs.filter((s) => !UPDATE_SKIP_UPLOAD_ERROR_KEYS.has(s.key));
}
